import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  alpha,
  useTheme,
  Tabs,
  Tab,
} from "@mui/material";
import {
  Medication as MedicationIcon,
  EventNote as EventNoteIcon,
} from "@mui/icons-material";
import { useParams } from "react-router-dom";
import useClientDetails from "../../../../hooks/useClientDetails";
import MedsList from "./MedsList/MedsList";
import MedicationEventHistory from "./MedEventHistory/MedEventHistory";

const Medications = () => {
  const theme = useTheme();
  const { id: clientID } = useParams();
  const { fullName } = useClientDetails(clientID);
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Card
        sx={{
          width: "100%",
          borderRadius: "14px",
          border: "1px solid #EAECF0",
          boxShadow: "0px 1px 3px rgba(16, 24, 40, 0.04)",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            px: 2.5,
            pt: 2,
            bgcolor: "#FFFFFF",
            borderBottom: "1px solid #EAECF0",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 1.5,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Box
                sx={{
                  width: 44,
                  height: 44,
                  borderRadius: "12px",
                  bgcolor: alpha(theme.palette.primary.main, 0.08),
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <MedicationIcon
                  sx={{ color: theme.palette.primary.main, fontSize: 24 }}
                />
              </Box>
              <Box>
                <Typography
                  sx={{
                    fontSize: "1.15rem",
                    fontWeight: 700,
                    color: "#101828",
                    letterSpacing: "-0.02em",
                    lineHeight: 1.3,
                  }}
                >
                  {fullName ? `${fullName}'s Medications` : "Medications"}
                </Typography>
                <Typography
                  sx={{ fontSize: "0.78rem", color: "#667085", mt: 0.4 }}
                >
                  Manage medications and event history
                </Typography>
              </Box>
            </Box>
          </Box>

          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            sx={{
              minHeight: 44,
              "& .MuiTabs-indicator": {
                backgroundColor: "#2469F0",
                height: 2.5,
                borderRadius: "3px 3px 0 0",
              },
              "& .MuiTab-root": {
                textTransform: "none",
                fontWeight: 600,
                fontSize: "0.85rem",
                minHeight: 44,
                color: "#667085",
                px: 2,
                "&.Mui-selected": {
                  color: "#2469F0",
                },
              },
            }}
          >
            <Tab
              icon={<MedicationIcon sx={{ fontSize: 20 }} />}
              iconPosition="start"
              label="Meds List"
              sx={{ gap: 0.75 }}
            />
            <Tab
              icon={<EventNoteIcon sx={{ fontSize: 20 }} />}
              iconPosition="start"
              label="Med Event History"
              sx={{ gap: 0.75 }}
            />
          </Tabs>
        </Box>

        <CardContent sx={{ p: 3 }}>
          {activeTab === 0 && <MedsList />}
          {activeTab === 1 && <MedicationEventHistory />}
        </CardContent>
      </Card>
    </Box>
  );
};

export default Medications;